app.factory('keyboardService', ['$rootScope', function ($rootScope) {
	var service = this;

	service.mediaQuery = window.matchMedia("only screen and (max-height: 500px)");
	service.mediaQuery.addListener(function(mediaQuery) {
		service.isShown = mediaQuery.matches;
		$rootScope.$broadcast('keyboardShownChanged', {shown: service.isShown});
	});

	service.isShown = service.mediaQuery.matches;
	$rootScope.$broadcast('keyboardShownChanged', {shown: service.isShown});

	return service;
}]);